import Helper from '@/Helper'
export default {
  getListGroupChecklistItem (state, payload) {
    state.group_checklist_items = payload
  },
  createGroupCheckItem (state, payload) {
    state.group_checklist_items.push(payload)
  },
  updateGroupChecklistItem (state, payload) {
    var data = []
    var items = []
    state.group_checklist_items.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.forEach(element => {
      if (parseInt(element.id) === parseInt(payload.id)) {
        element = payload
      }
      items.push(element)
    })
    state.group_checklist_items = Helper.getNestedChildren(items, 0)
  },
  createGroupChecklistItemChildren (state, payload) {
    var data = []
    state.group_checklist_items.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.push(payload)
    state.group_checklist_items = Helper.getNestedChildren(data, 0)
  },
  destroyGroupChecklistItem (state, payload) {
    var data = []
    var items = []
    state.group_checklist_items.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.forEach(element => {
      if (parseInt(element.id) === parseInt(payload.id)) {
      } else {
        items.push(element)
      }
    })
    state.group_checklist_items = Helper.getNestedChildren(items, 0)
  },
  setIsReject (state, payload) {
    var data = []
    state.group_checklist_items.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.map(element => {
      if (parseInt(element.id) === parseInt(payload.id)) {
        element.is_reject = 1
      }
      return element
    })
    state.group_checklist_items = Helper.getNestedChildren(data, 0)
  }
  // setIsApproval (state, payload) {
  //   var data = []
  //   state.group_checklist_items.forEach(element => {
  //     data = data.concat(Helper.getUnNestedChildren(element))
  //   })
  //   data.map(element => {
  //     if (parseInt(element.id) === parseInt(payload.id)) {
  //       element.is_reject = 0
  //     }
  //     return element
  //   })
  //   state.group_checklist_items = Helper.getNestedChildren(data, 0)
  // }
}



// WEBPACK FOOTER //
// ./src/store/module/group-checklist-item/mutations.js